import { Box, Button } from '@redbubble/design-system';
import React from 'react';
import { TopicNavItem } from './TopicNavItem/TopicNavItem';
var expandSideMenuTray = function () {
    var _a;
    (_a = document
        .querySelector('[data-testid="ds-header-hamburger-action"]')) === null || _a === void 0 ? void 0 : _a.click();
};
function renderSection(section) {
    var href = section.href, items = section.items, label = section.label;
    return (React.createElement(Box, { display: "flex", flex: "0 0 auto", alignItems: "center", paddingX: "xl", className: "rb-topic-nav__section" },
        React.createElement(Button, { type: "button", href: href || undefined, border: true, onClick: href ? undefined : expandSideMenuTray }, label),
        items.length > 0 && (React.createElement(Box, { display: "flex", alignItems: "center", className: "rb-topic-nav__section-children" }, items.map(function (_a) {
            var Icon = _a.icon, itemLabel = _a.label, active = _a.active, itemHref = _a.href;
            return Icon ? (React.createElement(TopicNavItem, { key: itemHref, label: itemLabel, active: active, Icon: Icon, href: itemHref })) : null;
        })))));
}
// Stub — the full component lands in DEAP-4435 (#3327).
export function TopicNav(_a) {
    var config = _a.config, _onEvent = _a.onEvent;
    var _b = config !== null && config !== void 0 ? config : {}, topics = _b.topics, products = _b.products;
    return (React.createElement(Box, { element: "nav", display: "flex", alignItems: "stretch", paddingY: "xs", className: "rb-topic-nav", "aria-label": "Topic navigation" },
        topics && renderSection(topics),
        products && renderSection(products)));
}
